export const MOBILE_BRANDING = {
    // ========================================================
    //  Colors
    // ========================================================
    MOBILE_GLOBAL_PRIMARY_TEXT_COLOR: 'MOBILE_GLOBAL_PRIMARY_TEXT_COLOR',
    MOBILE_GLOBAL_PRIMARY_BG_COLOR: 'MOBILE_GLOBAL_PRIMARY_BG_COLOR',
    MOBILE_GLOBAL_SECONDARY_TEXT_COLOR: 'MOBILE_GLOBAL_SECONDARY_TEXT_COLOR',
    MOBILE_GLOBAL_SECONDARY_BG_COLOR: 'MOBILE_GLOBAL_SECONDARY_BG_COLOR',
    MOBILE_GLOBAL_SECTION_HEADER_IS_SECONDARY_COLOR:
        'MOBILE_GLOBAL_SECTION_HEADER_IS_SECONDARY_COLOR',
    MOBILE_GLOBAL_SECTION_HEADER_BG_COLOR:
        'MOBILE_GLOBAL_SECTION_HEADER_BG_COLOR',
    MOBILE_GLOBAL_GRADIENT_THEME: 'MOBILE_GLOBAL_GRADIENT_THEME',
    MOBILE_GLOBAL_BTN_IS_SECONDARY_COLOR:
        'MOBILE_GLOBAL_BTN_IS_SECONDARY_COLOR',
    MOBILE_GLOBAL_BTN_BG_COLOR: 'MOBILE_GLOBAL_BTN_BG_COLOR',
    MOBILE_GLOBAL_BTN_TEXT_COLOR: 'MOBILE_GLOBAL_BTN_TEXT_COLOR',
    MOBILE_GLOBAL_HEADER_TEXT_COLOR: 'MOBILE_GLOBAL_HEADER_TEXT_COLOR',
    MOBILE_GLOBAL_HEADER_BG_COLOR: 'MOBILE_GLOBAL_HEADER_BG_COLOR',
    MOBILE_GLOBAL_ACCOUNTS_HEADER_TEXT_COLOR:
        'MOBILE_GLOBAL_ACCOUNTS_HEADER_TEXT_COLOR',
    MOBILE_GLOBAL_ACCOUNTS_HEADER_BG_COLOR:
        'MOBILE_GLOBAL_ACCOUNTS_HEADER_BG_COLOR',
    // ========================================================
    //  Logos
    // ========================================================
    MOBILE_GLOBAL_LOGO_LOGIN: 'MOBILE_GLOBAL_LOGO_LOGIN',
    MOBILE_GLOBAL_LOGO_ACCOUNTS: 'MOBILE_GLOBAL_LOGO_ACCOUNTS',
    // ========================================================
    //  Tablet (Login)
    // ========================================================
    TABLET_LOGIN_BG_IMG: 'TABLET_LOGIN_BG_IMG',
    // ========================================================
    //  Tablet (Accounts)
    // ========================================================
    TABLET_ACCOUNTS_BG_IMG: 'TABLET_ACCOUNTS_BG_IMG',
    // ========================================================
    //  PHONE (Login)
    // ========================================================
    PHONE_LOGIN_BG_IMG: 'PHONE_LOGIN_BG_IMG',
    // ========================================================
    //  PHONE (Accounts)
    // ========================================================
    PHONE_ACCOUNTS_BG_IMG: 'PHONE_ACCOUNTS_BG_IMG',
};

export const MOBILE_BRANDING_KEYS = {
    // ========================================================
    //  Colors
    // ========================================================
    [MOBILE_BRANDING.MOBILE_GLOBAL_PRIMARY_TEXT_COLOR]:
        'mobile.global.primary.textColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_PRIMARY_BG_COLOR]:
        'mobile.global.primary.bgColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_SECONDARY_TEXT_COLOR]:
        'mobile.global.secondary.textColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_SECONDARY_BG_COLOR]:
        'mobile.global.secondary.bgColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_SECTION_HEADER_IS_SECONDARY_COLOR]:
        'mobile.global.sectionHeader.isSecondaryColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_GRADIENT_THEME]:
        'mobile.global.gradientTheme',
    [MOBILE_BRANDING.MOBILE_GLOBAL_BTN_IS_SECONDARY_COLOR]:
        'mobile.global.button.isSecondaryColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_ACCOUNTS_HEADER_TEXT_COLOR]:
        'mobile.global.accountsPg.header.textColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_ACCOUNTS_HEADER_BG_COLOR]:
        'mobile.global.accountsPg.header.bgColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_HEADER_BG_COLOR]:
        'mobile.global.header.bgColor',
    [MOBILE_BRANDING.MOBILE_GLOBAL_HEADER_TEXT_COLOR]:
        'mobile.global.header.textColor',
    // ========================================================
    //  Logos
    // ========================================================
    [MOBILE_BRANDING.MOBILE_GLOBAL_LOGO_LOGIN]: 'mobile.global.loginPg.logo',
    [MOBILE_BRANDING.MOBILE_GLOBAL_LOGO_ACCOUNTS]:
        'mobile.global.accountsPg.header.logo',
    // ========================================================
    //  Tablet (Login)
    // ========================================================
    [MOBILE_BRANDING.TABLET_LOGIN_BG_IMG]: 'mobile.tablet.loginPg.bgImage',
    // ========================================================
    //  Tablet (Accounts)
    // ========================================================
    [MOBILE_BRANDING.TABLET_ACCOUNTS_BG_IMG]:
        'mobile.tablet.accountsPg.bgImage',
    // ========================================================
    //  PHONE (Login)
    // ========================================================
    [MOBILE_BRANDING.PHONE_LOGIN_BG_IMG]: 'mobile.phone.loginPg.bgImage',
    // ========================================================
    //  PHONE (Accounts)
    // ========================================================
    [MOBILE_BRANDING.PHONE_ACCOUNTS_BG_IMG]: 'mobile.phone.accountsPg.bgImage',
};
